import React, { useEffect, useState } from 'react'

export const SubtractionButton = () => {
    return (
        <span>
        <svg
            className='subtraction-symbol'
            width="25" 
            height="25" 
            viewBox="0 0 25 25"
            fill="currentColor"
        >
            <line strokeLinecap="round" stroke="white" strokeWidth="4" y2="12.5" x2="22.5" y1="12.5" x1="2.5"></line>
        </svg>
        </span>
    )
}